import { ErrorHandler, Injectable, Injector, isDevMode } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { ErrorService } from './error.service';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  constructor(private injector: Injector) {}

  handleError(error: unknown): void { 
    const errs = this.injector.get(ErrorService);
 
    if (error instanceof HttpErrorResponse) { 
      return;
    }

    const message = this.getMessage(error);
    const details = isDevMode() ? this.getDetails(error) : undefined;

    errs.show({
      title: 'frontend_error',
      message,
      time: new Date().toISOString(),
      details
    });
 
    if (isDevMode()) {
      console.error('GlobalErrorHandler:', error);
    }
  }

  private getMessage(error: unknown): string {
    if (error instanceof Error) return error.message || 'Unexpected UI error.';
    if (typeof error === 'string') return error;
    return 'Unexpected UI error.';
  }

  private getDetails(error: unknown): any {
    if (error instanceof Error) {
      return {
        name: error.name,
        message: error.message,
        stack: error.stack
      };
    }
    return error;
  }
}
